export default __webpack_public_path__ + "static/media/applications-image-02.54baf606.jpg";